<script lang="ts">
	import { Text, type TextPropsTypes } from '@Shelly/shelly-design-system';

	let className = '';
	export { className as class };
	export let title: string;
	export let style = '';
	export let styleType: TextPropsTypes['styleType'] = 'h2';
</script>

<Text {styleType} {style} class={className} noWrap>
	{title}
</Text>
